import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Scraps`

export function buscarTodosPorScraps(esScraps) {
  return http.get(`${API_ENDPOINT}/BuscarTodosPorScraps/${esScraps}`)
}
